import React from "react";
//*import PropTypes from 'prop-types';
import "./voicemailSkeleton.scss";
import { URAvaratSkeleton } from "./skeletonWidgets/avatar";
import { URLineSkeleton } from "./skeletonWidgets/lineSkeleton";
import { URboxSkeleton } from "./skeletonWidgets/boxDotSkeleton";
import { URButtonSkeleton } from "./skeletonWidgets/buttonSkeleton";
function URvoicemailSkeleton(props: any) {
  return (
    <>
      <div className="voicemailSkeleton">
        <div className="profileDesc">
          <URAvaratSkeleton className='avatar lg'/>
        </div>
        <div className="avtrDesc"><URLineSkeleton className='line lineThick size50'/></div>
        <div className="buttonList">
          <URButtonSkeleton className='skeletonBtn' />
          <URButtonSkeleton className='skeletonBtn' />
          <URButtonSkeleton className='skeletonBtn' />
        </div>
        <div className="buttonList">
          <URButtonSkeleton className='skeletonBtn' />
          <URLineSkeleton className='line lineThick size10'/>
          <URButtonSkeleton className='skeletonBtn' />
          <URLineSkeleton className='line lineThick size10'/>
          <URButtonSkeleton className='skeletonBtn' />
          <URLineSkeleton className='line lineThick size10'/>
        </div>
        <div className="voiceMailBox">
            
          <div className="audioSoundProgress">
            <div className="playIcn"><span className="icon_play"></span></div>
            <span></span>
            <span></span>
            <span></span>
            <span></span>
            <span></span>
            <span></span>
            <span></span>
            <span></span>
            <span></span>
            <span></span>
            <span></span>
            <span></span>
            <span></span>
            <span></span>
            <span></span>
            <span></span>
            <span></span>
            <span></span>
            <span></span>
            <span></span>
            <span></span>
            <span></span>
            <span></span>
            <span></span>
            <span></span>
            <span></span>
            <span></span>
            <span></span>
            <span></span>
            <span></span>
            <span></span>
            <span></span>
            <span></span>
            <span></span>
            <span></span>
            <span></span>
            <span></span>
            <div className="timeIcn"><span className="icon_Preview-minus"></span></div>
          </div>
          <div className="dotBoxLists">
            <URboxSkeleton className='avatarWithDot'/>
            <URboxSkeleton className='avatarWithDot'/>
            <URboxSkeleton className='avatarWithDot'/>
            <URboxSkeleton className='avatarWithDot'/>
          </div>
        </div>
      </div>
    </>

  );
}

export {
  URvoicemailSkeleton
};
